import clsx from 'clsx';
import {useRef} from 'react';
import {CloseIcon, SearchIcon} from '../../icons';
import Tooltip from '../../tooltip/tooltip';
import * as styles from './searchInput.module.css';
import ButtonIcon from '../../button/buttonIcon';

type SearchInputProps = {
    query: string,
    placeholder?: string,
    styleModificators?: {
        noPadding?: boolean,
    },
    isDirty?: boolean,
    isClearable?: boolean,
    handleChange: (value: string) => void,
    handleEnter?: (value: string) => void,
};

const SearchInput = ({
    query,
    handleChange,
    handleEnter,
    styleModificators = {},
    placeholder = 'Search',
    isDirty,
    isClearable,
}: SearchInputProps) => {
    const inputRef = useRef<HTMLInputElement | null>(null);
    const handleSearchQueryChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const value = event?.target?.value || '';

        handleChange(value);
    };

    const handleEnterKeyPress = (event: React.KeyboardEvent<HTMLInputElement>) => {
        if (!handleEnter || event.key !== 'Enter') {
            return;
        }

        const value = inputRef?.current?.value || '';

        handleEnter(value);
    };

    const handleClear = () => {
        handleChange('');
        handleEnter?.('');
    };

    return (
        <div
            className={clsx(
                styles.search,
                styleModificators.noPadding && styles.noPadding,
                isDirty && styles.isDirty,
            )}
        >
            <Tooltip
                text="Click on 'Search' button to apply query"
                disabled={!isDirty}
            >
                <SearchIcon />
            </Tooltip>
            <input
                ref={inputRef}
                className={styles.searchInput}
                value={query}
                onChange={handleSearchQueryChange}
                onKeyUp={handleEnterKeyPress}
                placeholder={placeholder}
            />
            {query?.length > 0 && isClearable && (
                <ButtonIcon
                    className={styles.clearButton}
                    isButton={true}
                    icon={CloseIcon}
                    tooltipText={'Clear search'}
                    onClick={handleClear}
                    isClose={true}
                />
            )}
        </div>
    );
};

export default SearchInput;
